import ModulePlanningLessonModelBase from '../_generated/modelBases/module-planning-lesson-model-base';

export default class ModulePlanningLessonModel extends ModulePlanningLessonModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
